import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/media/")({
  component: MediaIndex,
});

function MediaIndex() {
  return <Navigate to="/media/audio" />;
}
